import React from "react";
import { Link } from "react-router-dom";
import fe1 from "../../images/icon/1.png";
import fe2 from "../../images/icon/2.png";
import "./style.css";

const Features = () => {
  return (
    <div className="features-area">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6 col-sm-12 col-p">
            <a
              href="https://www.google.com/search?q=b+turner+law+firm+canada&rlz=1C1CHBF_enUS1075US1075&oq=b+turner+law&aqs=chrome.2.69i57j46i175i199i512j69i59j0i22i30j0i390i650l2j69i64j69i61.7066j0j7&sourceid=chrome&ie=UTF-8#lrd=0x4cce0fd9940df0fb:0x6199c27f5ae5a3f9,1,,,,"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="features-item-2">
                <div className="features-icon">
                  <i className="fi">
                    <img src={fe1} alt="Icon 1" />
                  </i>
                </div>
                <div className="features-content">
                  <p>Visit</p>
                  <h3>Reviews</h3>
                </div>
              </div>
            </a>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <a
              href="https://www.google.com/search?q=b+turner+law+firm+canada&rlz=1C1CHBF_enUS1075US1075&oq=b+turner+law&aqs=chrome.2.69i57j46i175i199i512j69i59j0i22i30j0i390i650l2j69i64j69i61.7066j0j7&sourceid=chrome&ie=UTF-8#lrd=0x4cce0fd9940df0fb:0x6199c27f5ae5a3f9,3,,,,"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="features-item-2">
                <div className="features-icon">
                  <i className="fi">
                    <img src={fe2} alt="Icon 2" />
                  </i>
                </div>
                <div className="features-content">
                  <p>Leave us a</p>
                  <h3>Review</h3>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
